import { useState, useRef, useContext } from 'react'
import { Button } from 'react-bootstrap'
import Badge from 'react-bootstrap/Badge'
import sha1 from 'sha1'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { LoginContext } from '../context/loginContext'
import createValidador from '../hooks/createValidador'
import ComponenteError from '../publicaciones/ComponenteError'
import * as loginService from '../servicios/loginService'
import Input from '../ui/Input'

const MAX_PASS_LENGTH = 50
const MIN_PASS_LENGTH = 10
const MENSAJE_OK = 17
const ERROR = 16

const Password = () => {
  const { loginDataContext } = useContext(LoginContext)
  const [loginData, setLoginData] = useState({
    idUsuario: loginDataContext.idUsuario,
    password: '',
    passwordConfirmar: ''
  })

  const { Validador } = createValidador()

  const esquema = {
    password: Validador.Kernel.string()
      .trim()
      .required()
      .max(MAX_PASS_LENGTH)
      .label('Password')
      .error((errors) => {
        return Validador.mensaje(errors)
      }),
    passwordConfirmar: Validador.Kernel.string()
      .trim()
      .required()
      .max(MAX_PASS_LENGTH)
      .label('Password confirmar')
      .valid(Validador.Kernel.ref('password'))
      .error((e) => {
        return Validador.mensaje(e, {
          'any.allowOnly': <>El password ingresado no coincide</>
        })
      })
  }
  const [errorCode, setErrorCode] = useState(0)
  const [errores, setErrores] = useState({})

  const fields = useRef(null)

  const [showEstadoPassword, setShowEstadoPassword] = useState('')
  const [estadoPassword, setEstadoPassword] = useState('')
  const [textoPassword, setTextoPassword] = useState('')
  const [passwordValido, setPasswordValido] = useState(false)

  const handleChange = (e) => {
    // TODO: SEGURIDAD - SHA1 es inseguro para passwords
    // El backend actualmente requiere SHA1. Se debe migrar a bcrypt/argon2
    // y mover el hashing al backend. Issue: [crear issue en GitHub]
    setLoginData({
      ...loginData,
      [e.target.name]: sha1(e.target.value) // nosemgrep: javascript.lang.security.insecure-hash-algorithm-sha1
    })
    showNivelPassword(e)
  }

  const showNivelPassword = (e) => {
    const exp1 = /[a-z]/
    const exp2 = /[0-9]/
    const exp3 = /[A-Z]/
    const valor1 = exp1.test(e.target.value)
    const valor2 = exp2.test(e.target.value)
    const valor3 = exp3.test(e.target.value)

    if (valor1 || valor2 || valor3) {
      setEstadoPassword('badge badge-danger')
      setTextoPassword('Poco segura')
      setPasswordValido(false)
    }
    if (
      (valor1 && !valor2 && valor3) ||
      (valor1 && valor2 && !valor3) ||
      (!valor1 && valor2 && valor3)
    ) {
      setEstadoPassword('badge badge-warning')
      setTextoPassword('Seguridad media')
      setPasswordValido(true)
    }
    if (valor1 && valor2 && valor3) {
      setEstadoPassword('badge badge-success')
      setTextoPassword('Muy segura')
      setPasswordValido(true)
    }
    if (e.target.value.length < MIN_PASS_LENGTH) {
      setEstadoPassword('badge badge-danger')
      setTextoPassword('Poco segura')
      setPasswordValido(false)
    }
    setShowEstadoPassword(true)
  }

  const cambiarPassword = async () => {
    try {
      //Esta encriptación SHA1 es momentánea en ambiente Testing,
      //hasta que hagamos el upgrade a SQL2016, en donde debemos realizar el UPDATE de este proceso a SHA2_256 o SHA2_512)
      if (valido('password') && valido('passwordConfirmar') && passwordValido) {
        const { data } = await loginService.cambiarPassword(loginData)
        fields.current.reset()
        parseInt(data.idUsuario) > 0 ? setErrorCode(MENSAJE_OK) : setErrorCode(ERROR)
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al cambiar la contraseña.`
      toastErrorLog(error, mensaje, 'login')
    }
  }

  const handleBlur = (e) => {
    valido(e.target.name)
  }

  const valido = (name) => {
    const error = Validador.validarDato(
      esquema,
      {
        password: loginData.password,
        passwordConfirmar: loginData.passwordConfirmar
      },
      name
    )
    setErrores(error || {})
    if (error) {
      return false
    } else {
      return true
    }
  }

  return (
    <>
      <div className="row">
        <div className="col">
          <br />
          <h2>Solicitaste cambiar tu contraseña</h2>
          <p>Completa los datos requeridos para cambiar tu contraseña.</p>
        </div>
        <div className="col">
          <form action="" ref={fields}>
            <br />
            <Input
              type="password"
              className="w-80 text-area"
              placeholder="Nueva contraseña"
              name="password"
              onChange={handleChange}
              onBlur={(e) => handleBlur(e)}
              errores={errores}
            />
            <h4>
              {showEstadoPassword && (
                <Badge variant={estadoPassword}>{textoPassword}</Badge>
              )}
            </h4>
            <Input
              type="password"
              className="w-80 text-area"
              placeholder="Confirmar contraseña"
              name="passwordConfirmar"
              onChange={handleChange}
              onBlur={(e) => handleBlur(e)}
              errores={errores}
            />
            <br />
            <br />
            <Button
              variant="sucess"
              className="btn btn-sign-in w-80"
              onClick={() => cambiarPassword()}
            >
              <i className="fa fa-key" aria-hidden="true" />
              &nbsp; Cambiar mi contraseña
            </Button>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          {errorCode === ERROR && <ComponenteError tipo="E" idAviso={errorCode} />}
          {errorCode === MENSAJE_OK && <ComponenteError tipo="I" idAviso={errorCode} />}
        </div>
      </div>
    </>
  )
}
export default Password
